module.exports = __webpack_public_path__ + "static/media/agrorprom.914a304b.jpg";